(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  if (!customElements.get('welcome-popup')) {
    const KEY = 'buvard-welcome-popup';
    const SUBMIT_KEY = 'buvard-welcome-popup-submitted';
    const store = {
      get(k, s = localStorage) { try { return s.getItem(k); } catch (e) { return null; } },
      set(k, v, s = localStorage) { try { s.setItem(k, v); } catch (e) {} },
      remove(k, s = localStorage) { try { s.removeItem(k); } catch (e) {} },
    };

    class WelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        const form = this.querySelector('form');
        const succeeded = !this.querySelector('[data-state="success"]').hidden;
        const hasError = !!this.querySelector('.welcome-popup__error');
        const submittedHere = store.get(SUBMIT_KEY, sessionStorage) === '1';

        this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
        this.dialog.addEventListener('cancel', () => this.remember());
        form.addEventListener('submit', () => store.set(SUBMIT_KEY, '1', sessionStorage));


        if (this.dataset.designMode === 'true') {
          document.addEventListener('shopify:section:select', (e) => { if (this.contains(e.target) || e.target.contains(this)) this.open(); });
          document.addEventListener('shopify:section:deselect', (e) => { if (this.contains(e.target) || e.target.contains(this)) this.dialog.close(); });
          return;
        }

        // Came back from submitting this pop-up's form: show the code or the error.
        if (submittedHere && (succeeded || hasError)) {
          store.remove(SUBMIT_KEY, sessionStorage);
          if (succeeded) store.set(KEY, 'subscribed');
          this.open();
          return;
        }
        if (succeeded) return; // a different sign-up form on the page succeeded

        const saved = store.get(KEY);
        if (saved === 'subscribed') return;
        const days = Number(this.dataset.days) || 0;
        if (saved && Date.now() - Number(saved) < days * 86400000) return;

        setTimeout(() => this.open(), (Number(this.dataset.delay) || 0) * 1000);
      }

      open() {
        if (this.dialog.open) return;
        if (document.querySelector('dialog[open]:not(.welcome-popup__dialog)')) return; // don't stack on cart/search
        this.dialog.showModal();
      }

      remember() {
        if (store.get(KEY) !== 'subscribed') store.set(KEY, String(Date.now()));
      }

      close() {
        this.remember();
        this.dialog.close();
      }
    }
    customElements.define('welcome-popup', WelcomePopup);
  }

  } catch(e) { console.error(e); }
})();
})();
